import { agroforestryProjectAllocations, landscapeRestorationProjectAllocations } from '../tree-projects';
import { ImpactFund } from '../types/projects';

export const builtInTreeMixes = {
  AGROFORESTRY: {
    title: 'Agroforestry mix',
    allocations: agroforestryProjectAllocations,
  },
  LANDSCAPE_RESTORATION: {
    title: 'Landscape restoration mix',
    allocations: landscapeRestorationProjectAllocations,
  },
} as const;

export type BuiltInTreeMixCode = keyof typeof builtInTreeMixes;

export type BuiltInImpactFundAllocation =
  | { type: 'PROJECT'; projectId: number; proportion: number }
  | { type: 'TREE_MIX'; treeMix: BuiltInTreeMixCode; proportion: number };

export type BuiltInImpactFundDefinition = {
  title: string;
  allocations: BuiltInImpactFundAllocation[];
};

export const builtInImpactFunds: Record<ImpactFund.FLIGHTS_OFFSET_FUND, BuiltInImpactFundDefinition> = {
  [ImpactFund.FLIGHTS_OFFSET_FUND]: {
    title: 'Flight emissions offset',
    allocations: [
      { type: 'PROJECT', projectId: 7067, proportion: 0.5 },
      { type: 'PROJECT', projectId: 10892, proportion: 0.35 },
      { type: 'PROJECT', projectId: 8843, proportion: 0.15 },
    ],
  },
};
